import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { selectorArg1 } from '../utils/selectors';
import { isNil } from 'lodash';

export const builderBinningSelector = createSelector(
  (state: RootState) => state,
  selectorArg1<number | undefined>(),
  (state, groupIndex) => {
    if (isNil(groupIndex)) {
      return state.builder.binning;
    } else {
      return state.builder.breakdown.groups[groupIndex].binning;
    }
  },
);

export const builderDefaultBinningSelector = (state: RootState) =>
  state.builder.binning;
